<template>
  <div>
    <v-card
      flat
      :loading="loading"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text class="black--text">
        <div>
          <naj-box title="بيانات القضية">
            <case-info
              v-if="requestDetails.case"
              no-header
              disable-items-per-page
              :headers="tableHeader"
              :loading="loading"
              :form-model="requestDetails.case ? requestDetails.case : null"
              :judgement-code="requestDetails.judgementCode"
              :no-margin-bottom="false"
            >
            </case-info>
          </naj-box>
          <request-applicant-details
            :view-mode="true"
            :form-model="requestDetails"
          ></request-applicant-details>
          <naj-box
            v-if="requestType.showRequestReasonSection"
            :title="local.caseRelatedRequest.requestReasons"
          >
            <template v-if="requestDetails.requestReasons && requestDetails.requestReasons.length">
              <naj-box
                v-for="(requestReason, index) in requestDetails.requestReasons"
                :key="index"
                :title="getMappedIndexReasonText(index)"
              >
                <v-row>
                  <v-col cols="6">
                    <label class="request-reason-label"> السبب</label>
                    <div>
                      <span class="request-reason-text">
                        {{ requestReason.reasonText }}
                      </span>
                    </div>
                  </v-col>

                  <v-col
                    class="text-center"
                    cols="4"
                  >
                    <template v-if="requestType.requestReasonTypeConfig.showRequestReasonAttachment">
                      <label class="request-reason-label"> {{ local.attachments.attachment }}</label>
                      <div
                        v-if="requestReason.sharePointId && requestReason.sharePointFileName"
                        class="d-flex justify-content-center align-items-center file-name h-75"
                      >
                        {{ requestReason.sharePointFileName }}
                      </div>
                    </template>
                  </v-col>

                  <v-col
                    class="d-flex justify-content-end align-items-center"
                    cols="2"
                  >
                    <v-btn
                      v-if="requestReason.sharePointId && requestReason.sharePointFileName"
                      icon
                      @click="handleViewAttachment(requestReason)"
                    >
                      <v-icon>
                        mdi-eye
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </naj-box>
            </template>
          </naj-box>
          <naj-dynamic-form
            :custom-component-name="requestType.customComponentName"
            :required-data="requestDetails.case"
            :form-model="requestDetails"
            :view-mode="true"
          ></naj-dynamic-form>

          <naj-box :title="local.caseFile.tabHeaders.fees">
            <v-row>
              <v-col cols="12">
                <span class="request-reasons-warning">
                  <v-icon color="#FAAD14">
                    mdi-alert
                  </v-icon>
                  {{ local.caseFile.fees.title }}
                </span>
                <div>
                  <span
                    v-if="requestTypeFeesDescription"
                    class="request-reason-text"
                  >
                    {{ requestTypeFeesDescription }}
                  </span>
                  <span
                    v-else
                    class="request-reason-text"
                  >
                    {{ local.caseFile.fees.noFees }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </naj-box>
          <render-attachment-modal
            :attachment-file="selectedFile"
            :modal-visibility="showViewAttachmentModal"
            @modalClose="hideViewAttachmentModal"
          >
          </render-attachment-modal>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RequestApplicantDetails from '../../request-applicant-details.vue';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
import { RequestTypes, partyTypeEnum, applicantRole } from '@/helpers/enum';
import CaseInfo from '../case-info.vue';
import { toHijriDate } from '../../../../../../../helpers/utils';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'RequestDetailsTab',
  components: {
    RequestApplicantDetails,
    RenderAttachmentModal,
    CaseInfo,
  },
  props: {
    requestDetails: {
      type: Object,
      required: true,
      default: () => { },
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tableHeader: [
        {
          value: 'judgementCode',
          text: this.local.caseReply.tableHeader.judgementCode,
        },
        {
          value: 'caseDate',
          text: this.local.caseReply.tableHeader.caseDate,
          formatter: toHijriDate,
        },
        {
          value: 'courtName',
          text: this.local.caseReply.tableHeader.court,
        },
        {
          value: 'subCircleName',
          text: this.local.caseReply.tableHeader.circle,
        },
        {
          value: 'caseStatusName',
          text: this.local.caseReply.tableHeader.caseStatusName,
        },
        {
          value: 'caseCategoryName',
          text: this.local.caseReply.tableHeader.caseCategoryName,
        },
        {
          value: 'caseTypeName',
          text: this.local.caseReply.tableHeader.caseType,
        },
      ],
      RequestTypes,
      requestTypeFeesDescription: null,
      showViewAttachmentModal: false,
      selectedFile: {},
      applicantRole,
    };
  },
  watch: {
    requestDetails(value) {
      if (value) {
        this.loadRequestTypeFeesDescription();
      }
    },
  },
  mounted() {
    this.loadRequestTypeFeesDescription();
  },
  methods: {
    ...mapActions([
      'getRequestFeesInfo',
    ]),
    getMappedIndexReasonText(index) {
      switch (index) {
        case 0:
          return 'السبب الأول';
        case 1:
          return 'السبب الثاني';
        case 2:
          return 'السبب الثالث';
        case 3:
          return 'السبب الرابع';
        case 4:
          return 'السبب الخامس';
        default:
          return '';
      }
    },
    handleViewAttachment(file) {
      this.$set(this, 'selectedFile', {
        name: file.fileName || file.sharePointFileName,
        isImage: !file.extension ? null : file.extension.startsWith('image'),
        sharePointId: file.sharePointId ?? file.sharepointId,
      });
      this.showViewAttachmentModal = true;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
    loadRequestTypeFeesDescription() {
      if (this.requestDetails && this.requestDetails.applicantInfo && this.requestDetails.applicantInfo.socialId) {
        this.loading = true;
        let applicant = this.requestDetails?.originalPersonParty?.socialId
          ? this.requestDetails.originalPersonParty
          : this.requestDetails.applicantInfo;

        if (this.requestDetails.applicantRoleId === this.applicantRole.organizationRepresentative) {
          applicant = this.requestDetails.originalPersonParty;
        }

        const identityNumber = this.requestDetails.applicantRoleId !== this.applicantRole.organizationRepresentative
          ? applicant.socialId
          : (this.requestDetails.originalPersonParty.unifiedNumber ?? this.requestDetails.originalPersonParty.commercialRegistrationNumber);

        const partyTypeId = this.requestDetails.applicantRoleId !== this.applicantRole.organizationRepresentative
          ? partyTypeEnum.person
          : (this.isGovernmentalUser ? partyTypeEnum.government : partyTypeEnum.firm);

        const params = {
          requestTypeId: 50,
          caseObjectKey: this.requestDetails.case.objectKey,
          applicantCasePartyId: 0,
          applicantInfo: {
            identityNumber: identityNumber,
            identityTypeId: applicant.socialIdType,
            partyTypeID: partyTypeId,
          },
        };
        this.getRequestFeesInfo(params)
          .then(({ data }) => {
            this.requestTypeFeesDescription = data.description;
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  computed: {
    ...mapLUTState(['yesOrNo']),
    requestType() {
      return this.RequestTypes[this.$route.params.requestType] || {};
    },
  },
};
</script>
<style lang="scss" scoped></style>
